
<template>
  <div class="province-city">
    <el-form-item class="page-form-item" label="省：" prop="status" style="width: calc(50% - 20px)">
      <el-select v-model="province" placeholder="请选择" @change="provinceChanged">
        <el-option :key="''" :label="'全部'" :value="''"></el-option>
        <el-option v-for="item in provinces" :key="item.code" :label="item.name" :value="item.name"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      class="page-form-item"
      label="市："
      prop="status"
      style="width: calc(50% - 20px);margin-right: 0px;margin-left:0.5rem"
    >
      <el-select v-model="city" :loading="loadingCity" @change="cityChanged" placeholder="请选择">
        <el-option :key="''" :label="'全部'" :value="''"></el-option>
        <el-option v-for="item in cities" :key="item.code" :label="item.name" :value="item.name"></el-option>
      </el-select>
    </el-form-item>
  </div>
</template>
 
<script type="text/javascript">
import provinceCity from "../assets/provinceCity.json";
export default {
  name: "provinceCity",
  props: {
    provinceCode: {
      type: String,
      default: "",
    },
    cityCode: {
      type: String,
      default: "",
    },
  },
  created() {
    this.provinces = provinceCity.provinces;
  },
  computed: {},
  mounted() {
    this.province = this.provinceCode;
    this.provinceChanged(this.provinceCode);
    this.city = this.cityCode;
  },
  data() {
    return {
      loadingCity: false,
      province: "",
      city: "",
      provinces: [],
      cities: [],
    };
  },
  methods: {
    provinceChanged(value) {
      if (value !== "") {
        this.loadingCity = true;
        for (var item of this.provinces) {
          if (item.name === value) {
            this.cities = item.cities;
            this.city = "";
            this.loadingCity = false;
            break;
          } else {
            continue;
          }
        }
      } else {
        this.cities = [];
        this.city = "";
      }
      this.$emit("selectChange", this.province, this.city);
    },
    cityChanged(value) {
      this.$emit("selectChange", this.province, this.city);
    },
    resetProviceCity(province, city) {
      this.cities = [];
      if (province && city) {
        this.province = province;
        this.provinceChanged(this.province);
        this.city = city;
      } else {
        this.province = "";
        this.city = "";
      }
    },
  },
};
</script>
 
<style >
.province-city {
  width: 100%;
  height: 40px;
  display: flex;
  align-content: center;
}
.province-city .el-form-item {
  border: none !important;
}
.province-city .el-input__inner {
  width: 1.4rem !important;
}
.province-city .el-form-item__label {
  width: auto !important;
}
.province-city .el-form-item__content {
  margin-left: 0px !important;
  display: flex;
}
</style>